import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DocumentSnapshot } from "firebase/firestore";
import dreamWorldProvider from "../DreamWorldProvider";
import { LibraryItem } from "../types/library";
import { RootState } from "./store";

interface TagState {
  content: LibraryItem[];
  hasMore: boolean;
  loading: "idle" | "pending" | "succeeded" | "failed";
  lastVisible: DocumentSnapshot | null;
  currentTag: string | null;
}

const initialState: TagState = {
  content: [],
  hasMore: true,
  loading: "idle",
  lastVisible: null,
  currentTag: null,
};

export const tagSlice = createSlice({
  name: "tag",
  initialState,
  reducers: {
    setTagContent: (state, action: PayloadAction<LibraryItem[]>) => {
      state.content = action.payload;
    },
    updateTagContent: (state, action: PayloadAction<LibraryItem>) => {
      const index = state.content.findIndex(
        (item) => item.id === action.payload.id
      );
      if (index !== -1) {
        state.content[index] = action.payload;
      }
    },
    resetTagContent: (state) => {
      state.content = [];
      state.hasMore = true;
      state.lastVisible = null;
      state.currentTag = null;
    },
  },
});

export const { setTagContent, updateTagContent, resetTagContent } =
  tagSlice.actions;

export const selectTagContent = (state: RootState) => state.tag.content;
export const selectTagHasMore = (state: RootState) => state.tag.hasMore;
export const selectTagLoading = (state: RootState) => state.tag.loading;

export default tagSlice.reducer;
